/* Region map hero: "Explore in 3D" (2026-10-12). Loads MapLibre only on tap, then swaps the satellite
   render for a live terrain map with the same camera, imagery and outline. Tiles are keyless:
   Esri World Imagery + the Mapterhorn DEM, the pair the Instagram region decks use. */
(function () {
  if (window.pwRegion3d) return;
  window.pwRegion3d = true;
  var V = '4.7.1', CDN = 'https://unpkg.com/maplibre-gl@' + V + '/dist/maplibre-gl.';
  var loading;
  function lib() {
    if (window.maplibregl) return Promise.resolve();
    if (loading) return loading;
    var css = document.createElement('link'); css.rel = 'stylesheet'; css.href = CDN + 'css'; document.head.appendChild(css);
    loading = new Promise(function (ok, fail) {
      var s = document.createElement('script'); s.src = CDN + 'js'; s.onload = ok; s.onerror = fail; document.head.appendChild(s);
    });
    return loading;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-pw-rhero-3d]');
    if (!btn) return;
    var wrap = btn.closest('[data-pw-rhero]');
    var cam = JSON.parse(wrap.dataset.camera);
    btn.disabled = true; btn.textContent = 'Loading 3D…';
    Promise.all([lib(), fetch(wrap.dataset.shape).then(function (r) { return r.json(); })]).then(function (res) {
      var shape = res[1];
      var el = document.createElement('div'); el.className = 'pw-rmap__gl'; wrap.insertBefore(el, wrap.firstChild);
      var dem = { type: 'raster-dem', url: 'https://tiles.mapterhorn.com/tilejson.json' };
      var touch = window.matchMedia('(pointer: coarse)').matches;
      var map = new maplibregl.Map({
        container: el, center: cam.center, zoom: cam.zoom, pitch: cam.pitch, bearing: cam.bearing,
        maxPitch: 75, cooperativeGestures: touch, attributionControl: { compact: true, customAttribution: 'Imagery: Esri, Maxar, Earthstar Geographics' },
        style: {
          version: 8,
          sources: {
            sat: { type: 'raster', tiles: ['https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'], tileSize: 256, maxzoom: 19 },
            dem: dem, hs: dem,
            region: { type: 'geojson', data: shape }
          },
          terrain: { source: 'dem', exaggeration: 1.6 },
          layers: [
            { id: 'sat', type: 'raster', source: 'sat' },
            { id: 'hs', type: 'hillshade', source: 'hs', paint: { 'hillshade-shadow-color': 'rgba(20,16,10,0.32)', 'hillshade-highlight-color': 'rgba(255,250,235,0.22)', 'hillshade-accent-color': 'rgba(0,0,0,0.12)', 'hillshade-exaggeration': 0.45 } },
            { id: 'fill', type: 'fill', source: 'region', paint: { 'fill-color': '#CEB7EF', 'fill-opacity': 0.22 } },
            { id: 'line', type: 'line', source: 'region', paint: { 'line-color': '#ffffff', 'line-width': 1 } }
          ]
        }
      });
      map.addControl(new maplibregl.NavigationControl({ visualizePitch: true }), 'top-right');
      map.once('load', function () {
        wrap.classList.add('is-3d');
        var hint = document.createElement('span'); hint.className = 'pw-rmap__hint';
        hint.textContent = touch ? 'Use two fingers to move and tilt' : 'Drag to move. Right-drag to tilt and turn';
        wrap.appendChild(hint);
        setTimeout(function () { hint.style.opacity = '0'; }, 4000);
      });
    }).catch(function () { btn.disabled = false; btn.textContent = 'Explore in 3D'; });
  });
})();
